module.exports = __webpack_public_path__ + "img/pencil.7fa45bcf.svg";